<template>
    <div class="device-type-manange relative">
        <div class="buttons">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button :id="'systemUserAdd'" @click="addDeviceType">新增</el-button>
        </div>
        <!-- 表单开始 -->

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="8" :lg="8" :xl="5">
                <span class="fs-14 pd-r-10">搜索：</span>
                <el-input style="width: 100%;" v-model="search_data" placeholder="登录账户/姓名/电话模糊搜索"/>
            </el-col>
            <el-col :md="8" :lg="8" :xl="5">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <el-table :data="tableData" border style="width: 100%">
<!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="account" label="用户名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="role_name" label="角色" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="mobile" label="联系电话" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="email" label="邮箱地址" align="center" label-class-name="label"></el-table-column>
<!--            <el-table-column prop="created_time" label="加入时间" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="last_login_time" label="最后登录时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'systemUserEdit'" @click="goEdit(scope.row)" v-if="scope.row.is_admin==0" type="text">
                    编辑
                </el-button>
                <el-button :id="'systemUserDel'" @click="del_user(scope.row)" v-if="scope.row.is_admin==0" type="text">
                    删除
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
        <!-- 删除确认 弹窗 -->
        <el-dialog
                title="提示"
                :visible.sync="deleteDialogVisible"
                width="20%"
                :before-close="done => done()"
                center
                top="20%"
        >
            <span style="display: block; text-align: center;">确认删除？</span>
            <span slot="footer" class="dialog-footer">
        <el-button @click="deleteData('cancel')">取消</el-button>
        <el-button type="primary" @click="deleteData('sure')">确定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";
    import {getUserInfos} from '@/utils/userInfos';

    export default {
        data() {
            return {
                search_data: null,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                //删除确认
                deleteDialogVisible: false,
                delete_id: '',
                is_submit: false,
            };
        },
        mounted() {
            this.search_data = this.$route.params.user_name
            // 获取列表
            this.getList();
            localStorage.setItem('prev_page', 'administrator_list')
        },
        methods: {
            // 获取所有设备类型
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'administratorsListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        search_data: this.search_data
                    },
                    user_account: this.user_account,
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },
            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 跳转编辑页
            goEdit(data) {
                this.$router.push({
                    name: "administratorsEdit",
                    params: {
                        id: data.id,
                        account: data.account,
                        user_name: data.user_name,
                        email: data.email,
                        mobile: data.mobile,
                        password_len: data.password_len,
                        password: data.password,
                        role_id: data.role_id,
                        company_id:data.company_id,
                        department_id:data.department_id==0?"":data.department_id,
                        group_id:data.group_id==0?"":data.group_id,
                        introduction: data.introduction,
                        user_avatar: data.user_avatar,
                        posistion: data.posistion,
                        user_title: data.user_title,
                    }
                });
            },
            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.search_data = "";
                this.getList();
            },
            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            // 跳转添加页
            addDeviceType() {
                this.$router.push({name: "administratorsAdd", params: {}});

            },

            // 删除账号
            del_user(val) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let userData = getUserInfos();
                var message = '确定该删除该管理员吗?';
                if (val.id == userData.id) {
                    message = '确定删除正在登陆的账号吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'deleteAccount',
                        params: {
                            id: val.id,
                            isLog: 1,
                            isId: val.id,
                            actionId: 4,
                            isSelf: 1
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message.success('删除成功！');
                        this.getList();
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>
